<template>
  <template-list
    :model="crossSellModel"
    :items="list"
    titleClass="text-h5 font-weight-bold"
    titleStyle="color: black"
    :show-create-button="false"
    :showDivider="false"
  >
    <template v-slot:actions>
      <search
        :rounded="false"
        always
        v-model="search"
      ></search>
    </template>
    <template v-slot="{ object }">
      <v-col>
        <IngredientCell
          class="mt-2 mb-2"
          :item="object"
          @click="select(object)"
        />
      </v-col>
    </template>
  </template-list>
</template>

<script>
  import search from 'air-vue-model/search'
  import Search from '@/components/template/Search'
  import DiscountSystemInformation from '@/admin/views/discountSystems/DiscountSystemInformation.vue'
  import IngredientCell from './IngredientCell.vue'
  import { CrossSell } from '@/models/crossseil.js'

  export default {
    name: 'SelectableIngredientGroupList',
    components: {
      DiscountSystemInformation,
      Search,
      IngredientCell
    },
    props: {
      selectedIngredients: []
    },
    data: () => ({
      search: null,
      availableProductItems: [],
      crossSellModel: new CrossSell({
        text: {
          listTitle: 'Доступные модификаторы'
        }
      })
    }),
    methods: {
      filterItems(items) {
        return search(this.search, items, val => val.name)
      },
      select(item) {
        this.$emit('select', item)
      }
    },
    computed: {
      list() {
        const newCrossSellModelList = this.crossSellModel.list.map(e => e)

        if (!this.search) return newCrossSellModelList
        return this.filterItems(newCrossSellModelList)
      }
    },
    mounted() {
      this.crossSellModel.sendRequest(null, 'available_products', null, 'get').then(res => {
        this.crossSellModel.list = res.filter(
          e =>
            !this.selectedIngredients.some(
              item => item.ingredient === e.ingredient && item.product === e.product
            )
        )
      })
    }
  }
</script>
